// Excuded categories to get all accounts
export const ACCOUNTS_PRODUCT_CATEGORIES = ['CNL_ACCOUNT'];
// Only limits category
export const LIMITS_PRODUCT_CATEGORIES = ['CNL_ACCOUNT'];
